import { Box, Typography, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

export const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        py: 1,
        textAlign: 'center',
        backgroundColor: 'transparent',
      }}
    >
      <Typography
        variant="caption"
        sx={{
          color: 'text.secondary',
          fontSize: '0.75rem',
          fontWeight: 300,
        }}
      >
        © 2026 Canadawale Yar. All Rights Reserved. CWY Admin Portal v{__APP_VERSION__} |{' '}
        <Link
          component={RouterLink}
          to="/privacy"
          sx={{
            color: 'text.secondary',
            textDecoration: 'none',
            '&:hover': {
              textDecoration: 'underline',
            }
          }}
        >
          Privacy Policy
        </Link>
        {' | '}
        <Link
          component={RouterLink}
          to="/terms-of-service"
          sx={{
            color: 'text.secondary',
            textDecoration: 'none',
            '&:hover': {
              textDecoration: 'underline',
            }
          }}
        >
          Terms of Service
        </Link>
        {' | '}
        <Link
          component={RouterLink}
          to="/data-deletion"
          sx={{
            color: 'text.secondary',
            textDecoration: 'none',
            '&:hover': {
              textDecoration: 'underline',
            }
          }}
        >
          Data Deletion
        </Link>
      </Typography>
    </Box>
  );
}; 